// extracted by mini-css-extract-plugin
export default {"card":"reviews_card__J4hH7","img":"reviews_img__RrgGx","text":"reviews_text__rJqMk","rating":"reviews_rating__2-gpU","title":"reviews_title__Aoapj"};